// Menu order everywhere (spec 2026-10-12 §6.2): order lines and their
// options are listed the way the menu editor lists them. thisway-api works
// that order out and stamps `sortorder` (1-based) on every line of an order
// and on every option row of a line; the dashboard follows it and never
// re-derives the rule.
//
// An API from before that change sends no `sortorder`, and write endpoints
// answer 0: when any row of a list lacks a positive one, the whole list
// keeps today's behaviour. Lines stay in the order the API sent them;
// options go by their group's order, then their own, then name, then row
// id (the old `sortOptions` of items-list.js and receipt.js, made total).
// Both functions return a new array and never touch the input.

const hasRank = (row) => Number.isInteger(row?.sortorder) && row.sortorder > 0;

const allRanked = (rows) => rows.length > 0 && rows.every(hasRank);

const byRank = (a, b) => a.sortorder - b.sortorder;

// A missing display order counts as 0.
const displayOrder = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

// Ordinal, like the API: never localeCompare.
const compareText = (a, b) => {
  const x = a == null ? '' : String(a);
  const y = b == null ? '' : String(b);
  if (x < y) return -1;
  if (x > y) return 1;
  return 0;
};

const byGroupThenOption = (a, b) =>
  displayOrder(a?.optiongroupdisplayorder) -
    displayOrder(b?.optiongroupdisplayorder) ||
  displayOrder(a?.displayorder) - displayOrder(b?.displayorder) ||
  compareText(a?.name, b?.name) ||
  compareText(a?.id, b?.id);

export const inMenuOrder = (orderitems) => {
  if (!Array.isArray(orderitems)) return [];
  const lines = [...orderitems];
  return allRanked(lines) ? lines.sort(byRank) : lines;
};

export const optionsInMenuOrder = (options) => {
  if (!Array.isArray(options)) return [];
  return [...options].sort(allRanked(options) ? byRank : byGroupThenOption);
};
